import type { CreditUsageWarning } from '../../types';
import { WARNING_SEVERITY_TO_ALERT_VARIANT } from '../../types/WarningSeverity';
import { format } from '../../utils';
import { Alert } from '../Alert';
import { VStack } from '../Core';
import { Text } from '../Text';

interface CreditUsageWarningsProps {
  warning: CreditUsageWarning;
  isWarningAggregatedFromChild?: boolean;
  variant?: 'default' | 'mobileDetail';
}

export function CreditUsageWarnings({
  warning,
  isWarningAggregatedFromChild = false,
  variant = 'default',
}: CreditUsageWarningsProps) {
  const { currency, usage, severity } = warning;
  const isMobileDetail = variant === 'mobileDetail';
  const message = `${currency} at ${format(usage.times(100), { spec: '0', round: true })}% of limit`;

  if (isMobileDetail) {
    return (
      <Alert w="100%" variant={WARNING_SEVERITY_TO_ALERT_VARIANT[severity]} dismissable={false} fontSize="fontSizeMd">
        <VStack alignItems="flex-start" gap="spacing4" w="100%" data-testid="credit-usage-warning-tooltip-content">
          {isWarningAggregatedFromChild ? (
            <Text fontWeight="fontWeightMedium" color="colorTextSubtle">
              Within Group
            </Text>
          ) : null}
          <Text size="fontSizeMd" color="colorTextDefault" textAlign="left">
            {message}
          </Text>
        </VStack>
      </Alert>
    );
  }

  return (
    <VStack gap="spacing4" alignItems="flex-start" data-testid="credit-usage-warning-tooltip-content">
      {isWarningAggregatedFromChild ? (
        <Text fontWeight="fontWeightMedium" color="colorTextSubtle">
          Within Group
        </Text>
      ) : null}
      <Text size="fontSizeMd" color="gray.100">
        {message}
      </Text>
    </VStack>
  );
}
